import { useCountPatchedFields } from 'components/common-form/hooks/patched-fields/useCountPatchedFields';
import { LightAlert } from 'components/shared/LightAlert';
import { useMemo } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import type { ModifiedTabCandidate } from 'state/selectors/common/modified-tabs-info';

type ModifiedTabsInfoProps = Readonly<{
  candidates: readonly ModifiedTabCandidate[];
}>;

export function ModifiedTabsInfo({ candidates }: ModifiedTabsInfoProps) {
  const intl = useIntl();
  const fieldIdsByTab = useMemo(() => candidates.map(candidate => candidate.fieldIds), [candidates]);
  const modifiedCounts = useCountPatchedFields(fieldIdsByTab);

  const modifiedTabNames = candidates
    .filter((_candidate, index) => modifiedCounts[index] > 0)
    .map(candidate => intl.formatMessage({ id: candidate.labelKey }));

  if (modifiedTabNames.length === 0) {
    return undefined;
  }

  return (
    <LightAlert severity="info" e2e="modified-tabs-info">
      <FormattedMessage
        id="sidePanel.modifiedTabs"
        values={{ count: modifiedTabNames.length, tabs: intl.formatList(modifiedTabNames) }}
      />
    </LightAlert>
  );
}
